import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import muteIcon from "../../../assets/images/icons/mute-icon.svg";
import unmuteIcon from "../../../assets/images/icons/unmute-icon.svg";
import { useSelector } from "react-redux";
import useElementOnScreen from "../../common/customHooks/useElementOnScreen";

export default function DetailVideoSlides({
  isDetailMuted,
  setisDetailMuted,
  video,
}) {
  // pass itMuted and setisMuted as props from parent Component for single click mute
  // const [isMuted, setisMuted] = useState(true)

  const [isVideoPlaying, setisVideoPlaying] = useState(false);

  const videoRef = useRef(null);
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.7,
  };
  const isVisibile = useElementOnScreen(options, videoRef);

  useEffect(() => {
    // window.addEventListener("resize", handleResize)

    if (isVisibile) {
      if (!isVideoPlaying) {
        const promise = videoRef.current.play();
        // console.log(videoRef)
        promise
          .then(() => {
            setisVideoPlaying(true);
          })
          .catch((error) => {
            setisVideoPlaying(false);
          });
      }
    } else {
      if (isVideoPlaying) {
        // videoRef.current.pause();
        videoRef.current.pause();
        setisVideoPlaying(false);
      }
    }
  }, [isVisibile]);

  // const onVideoClick = () => {
  //   // console.log(isVideoPlaying)
  //   // if (isVideoPlaying) {
  //   //   videoRef.current.pause()
  //   //   setisVideoPlaying(!isVideoPlaying)
  //   // } else {
  //   //   videoRef.current.play()
  //   //   setisVideoPlaying(!isVideoPlaying)
  //   // }
  //   if (props.isMuted) {
  //     props.setisMuted(false)
  //   } else {
  //     props.setisMuted(true)
  //   }
  // }

  const muteHandle = () => {
    if (isDetailMuted) {
      setisDetailMuted(false);
    } else {
      setisDetailMuted(true);
    }
  };

  return (
    <div
      style={{ position: "relative", background: "white" }}
      onClick={muteHandle}
    >
      <video
        ref={videoRef}
        src={video.src2}
        // autoPlay={true}
        muted={isDetailMuted}
        // onPlaying={() => {
        //   console.log('played::', props.index)
        // }}
        poster={video.thumbnail}
        style={{
          width: "100%",
          //   height: '100vh',
          objectFit: "cover",
          background: "transparent",
        }}
        className="dynamic-height"
        loop
        playsInline
      ></video>
      <img
        src={isDetailMuted ? muteIcon : unmuteIcon}
        alt="mute-icon"
        className={!isDetailMuted && "fade-out-icon"}
        style={
          // isMuted
          // ?
          {
            position: "absolute",
            top: "46%",
            left: "50%",
            transform: "translate(-50%, -46%)",
            zIndex: "2",
            width: "55px",
            height: "auto",
            cursor: "pointer",
          }
          // : { display: 'none' }
        }
      ></img>
    </div>
  );
}
